import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/consult';
import List from '../../List/List';
import {TONOMETRY} from "../../../../../utility/variables";
import {resetStore} from "../../../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.consult,
        titulo: 'TONOMETRÍA',
        show_list: TONOMETRY,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(List);
